/**
 * AdminService — админ-раздел Старт-класса: заявки, центры, счета, сводка.
 *
 * Доступен только глобальному администратору: бэкенд проверяет role=admin
 * в токене и отдаёт 403 всем остальным. Фронт эту проверку дублирует лишь
 * для того, чтобы не показывать вкладку, которой всё равно не воспользуешься.
 */
import axios from 'axios';
import { B2B_BASE } from './API';

const TOKEN_KEY = 'Authorization';
const authHeaders = () => ({ Authorization: localStorage.getItem(TOKEN_KEY) });

const ADMIN = `${B2B_BASE}/api/v1/b2b/admin`;

export default class AdminService {

    /** Сводные цифры для дашборда. */
    static async getSummary() {
        const res = await axios.get(`${ADMIN}/summary`, { headers: authHeaders() });
        return res.data;
    }

    /** Заявки «выставить счёт» и «перезвонить». */
    static async getRequests({ kind, status } = {}) {
        const params = {};
        if (kind) params.kind = kind;
        if (status) params.status = status;
        const res = await axios.get(`${ADMIN}/requests`, { headers: authHeaders(), params });
        return res.data;
    }

    /** Сменить статус заявки или оставить заметку. */
    static async updateRequest(id, patch) {
        const res = await axios.patch(`${ADMIN}/requests/${id}`, patch, { headers: authHeaders() });
        return res.data;
    }

    /** Все центры со сроком действующей подписки. */
    static async getCentres({ status } = {}) {
        const params = {};
        if (status) params.status = status;
        const res = await axios.get(`${ADMIN}/centres`, { headers: authHeaders(), params });
        return res.data;
    }

    /** Карточка центра: реквизиты, счета, заявки, подписки. */
    static async getCentre(id) {
        const res = await axios.get(`${ADMIN}/centres/${id}`, { headers: authHeaders() });
        return res.data;
    }

    /**
     * Выставить счёт центру.
     * plan: 'monthly' | 'yearly_standard' | 'yearly_early'
     * amount — рубли; не передан → берётся из прайса.
     */
    static async createInvoice(centreId, { plan, amount, due_days, comment } = {}) {
        const body = { plan };
        if (amount) body.amount = amount;
        if (due_days) body.due_days = due_days;
        if (comment) body.comment = comment;
        const res = await axios.post(`${ADMIN}/centres/${centreId}/invoices`, body,
            { headers: authHeaders() });
        return res.data;
    }

    /** Все счета. */
    static async getInvoices({ status } = {}) {
        const params = {};
        if (status) params.status = status;
        const res = await axios.get(`${ADMIN}/invoices`, { headers: authHeaders(), params });
        return res.data;
    }

    /** Оплата по счёту поступила — выдать центру доступ. */
    static async markPaid(invoiceId) {
        const res = await axios.post(`${ADMIN}/invoices/${invoiceId}/paid`, {},
            { headers: authHeaders() });
        return res.data;
    }

    /** Аннулировать счёт. */
    static async cancelInvoice(invoiceId) {
        const res = await axios.post(`${ADMIN}/invoices/${invoiceId}/cancel`, {},
            { headers: authHeaders() });
        return res.data;
    }
}
